module.exports = __webpack_public_path__ + "static/img/Alliance.b2f6af8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/Alliance.png
// module id = iiMW
// module chunks = 0